import React from 'react'

// Modify React UseEffect to not run on mount
const useDidMountEffect = (func, deps) => {
  const didMount = React.useRef(false)

  React.useEffect(() => {
    if (didMount.current) func()
    else didMount.current = true
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}

export default useDidMountEffect
